// extracted by mini-css-extract-plugin
export var layoutContainer = "_7h-0";
export var layoutContainerNoRounding = "_7h-6";
export var layoutContainerOpen = "_7h-5";
export var layoutContainerResizing = "_7h-1";
export var mainContent = "_7h-2";
export var resizeDivider = "_7h-3";
export var slidePanel = "_7h-4";